import { Provider } from "react-redux";
import { ThemeProvider } from "next-themes";
import VideoPlayer from "./videoPlayer";
import store from "redux-share/store";
import { IParams } from "interfaces";
import { memo } from "react";
import ErrorBoundary from "./errorBoundary";

const VideoPlayerLibrary = (props: IParams) => {
    return (
        <Provider store={store}>
            <ThemeProvider enableSystem={true} attribute="class">
                <ErrorBoundary>
                    <VideoPlayer params={props} />
                </ErrorBoundary>
            </ThemeProvider>
        </Provider>
    );
};

export default memo(VideoPlayerLibrary);
